// react
import React from 'react';
// style
import './style/ability.css'
const Ability = () => {
    return (
        <>
            <div className={'row mt-4'}>
                <div className={'col-md-3 col-6 mb-md-0 mb-4'} data-aos="zoom-in-up" data-aos-duration={'1000'}>
                    <div className={'ability-card shadow'}>
                        <div className={'card-image first-ability'}>
                            <div className={'d-flex align-items-end h-100'}>
                                <div className='texts px-3'>
                                    <p className={'text-white h5 fw-bold mb-2'}>
                                        تور 360 درجه
                                    </p>
                                    <p className='font-medium-lg text-white ability-description'>
                                        با تور 360 درجه وب‌سایت ما، ملک دلخواهتان را از هر زاویه و بدون نیاز به بازدید حضوری مشاهده کنید!
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'col-md-3 col-6 mb-md-0 mb-4'} data-aos="zoom-in-down" data-aos-duration={'1000'}>
                    <div className={'ability-card shadow'}>
                        <div className={'card-image second-ability'}>
                            <div className={'d-flex align-items-end h-100'}>
                                <div className='texts px-3'>
                                    <p className={'text-white h5 fw-bold mb-2'}>
                                        مشاوره
                                    </p>
                                    <p className='font-medium-lg text-white ability-description'>
                                        خدمات مشاوره تخصصی ما به شما کمک می‌کند تا بهترین تصمیمات را در خرید، فروش و اجاره املاک بگیرید
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'col-md-3 col-6 mb-md-0 mb-4'} data-aos="zoom-in-up" data-aos-duration={'1000'}>
                    <div className={'ability-card shadow'}>
                        <div className={'card-image third-ability'}>
                            <div className={'d-flex align-items-end h-100'}>
                                <div className='texts px-3'>
                                    <p className={'text-white h5 fw-bold mb-2'}>
                                        فیلم برداری
                                    </p>
                                    <p className='font-medium-lg text-white ability-description'>
                                        با خدمات فیلم‌برداری حرفه‌ای ما، املاک شما با کیفیت بالا و از بهترین زاویه‌ها نمایش داده می‌شود
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'col-md-3 col-6 mb-md-0 mb-4'} data-aos="zoom-in-down" data-aos-duration={'1000'}>
                    <div className={'ability-card shadow'}>
                        <div className={'card-image fourth-ability'}>
                            <div className={'d-flex align-items-end h-100'}>
                                <div className='texts px-3'>
                                    <p className={'text-white h5 fw-bold mb-2'}>
                                        عکاسی
                                    </p>
                                    <p className='font-medium-lg text-white ability-description'>
                                        با خدمات عکاسی حرفه‌ای ما، املاک شما در بهترین نور و زاویه به نمایش درمی‌آید
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Ability;